var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-notification',{attrs:{"closable":false}},[_vm._v(" Loading the application "),_c('b-loading',{attrs:{"is-full-page":true,"active":true,"can-cancel":false},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }